var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import AjaxHelper from "../helper/AjaxHelper.js";
import BrowserHelper from "../helper/BrowserHelper.js";
import DomHelper from "../helper/DomHelper.js";
import ResizeHelper from "../helper/ResizeHelper.js";
import CodeEditor from "./CodeEditor.js";
import Combo from "./Combo.js";
import PanelCollapserOverlay from "./panel/PanelCollapserOverlay.js";
import Widget from "./Widget.js";
const fileStart = {
  lineNumber: 0,
  column: 0
}, fileEnd = {
  lineNumber: Number.MAX_SAFE_INTEGER,
  column: Number.MAX_SAFE_INTEGER
}, isBryntumCom = BrowserHelper.isBryntumOnline(["online"]), { pathname } = globalThis.location, isUmd = pathname.endsWith("umd.html"), moduleTag = document.querySelector("script[type=module]"), isModule = pathname.endsWith("module.html") || (moduleTag == null ? void 0 : moduleTag.src.includes("app.module.js")) || pathname.endsWith("index.html") && isBryntumCom;
const _DemoCodeEditor = class _DemoCodeEditor extends CodeEditor {
  //endregion
  construct(config = {}) {
    super.construct(...arguments);
    const me = this, { rtl } = me;
    if (rtl) {
      me.collapsible.direction = "left";
    }
    new ResizeHelper({
      targetSelector: ".b-codeeditor",
      rightHandle: Boolean(rtl),
      leftHandle: !rtl,
      skipTranslate: true,
      minWidth: 190
    });
  }
  get isVanilla() {
    return this.mode === "vanilla";
  }
  get isFramework() {
    return this.mode === "framework";
  }
  updateMode() {
    this.title = '<span class="title-container"><span class="title">' + (this.isVanilla ? "L{CodeEditor.editor}" : "L{CodeEditor.viewer}") + "</span></span>";
  }
  onCloseClick() {
    this.collapse();
  }
  async onFilesComboChange({ value }) {
    await this.loadCode(value);
  }
  async collapseBoilerplate(model) {
    const {
      monacoInstance,
      editor
    } = this, { Selection } = monacoInstance, selections = [], imports = model.findMatches("^import .*$", true, true);
    let blockStart, blockEnd = true;
    [
      "baselines",
      "children",
      "segments",
      "intervals",
      "events",
      "tasks",
      "resources",
      "assignments",
      "dependencies",
      "timeRanges",
      "resourceTimeRanges",
      "rows"
    ].forEach((blockName) => {
      const blockStartMatch = `${blockName}\\s*(?:=|:)\\s*\\[`;
      for (blockStart = model.findForwards(blockStartMatch, fileStart, true); blockStart && blockEnd; blockStart = model.findForwards(blockStartMatch, blockEnd.range.getEndPosition(), true)) {
        blockEnd = model.findForwards("\\](?:;|,)?\\s*$", blockStart.range.getEndPosition(), true);
        if (blockEnd) {
          while (blockEnd && selections.some((s) => s.containsRange(blockEnd.range))) {
            blockEnd = model.findForwards("\\](?:;|,)?\\s*$", blockEnd.range.getEndPosition(), true);
          }
          if (blockEnd) {
            selections.push(new Selection(blockStart.range.startLineNumber, 1, blockEnd.range.endLineNumber + 1, 1));
          }
        }
      }
    });
    let hideStart, lastRangeEnd = fileStart;
    while (hideStart = model.findForwards("^\\s*//\\s*hide", lastRangeEnd, true)) {
      const hideEnd = model.findForwards("^\\s*//\\s*end(?:-|(?:\\s*))?hide", {
        lineNumber: hideStart.range.endLineNumber,
        column: 0
      }, true);
      if (hideEnd) {
        selections.push(new Selection(hideStart.range.startLineNumber, 1, hideEnd.range.endLineNumber + 1, 1));
      }
      lastRangeEnd = (hideEnd == null ? void 0 : hideEnd.range.getEndPosition()) || fileEnd;
    }
    lastRangeEnd = fileStart;
    while (hideStart = model.findForwards("^\\s*//\\s*region", lastRangeEnd, true)) {
      const hideEnd = model.findForwards("^\\s*//\\s*end(?:-|(?:\\s*))?region", {
        lineNumber: hideStart.range.endLineNumber,
        column: 0
      }, true);
      if (hideEnd) {
        selections.push(new Selection(hideStart.range.startLineNumber, 1, hideEnd.range.endLineNumber + 1, 1));
      }
      lastRangeEnd = (hideEnd == null ? void 0 : hideEnd.range.getEndPosition()) || fileEnd;
    }
    if (imports.length) {
      selections.push(new Selection(1, 1, imports[imports.length - 1].range.startLineNumber + 1, 1));
    }
    for (const selection of selections) {
      editor.setSelections([...editor.getSelections(), selection]);
      await editor.getAction("editor.createFoldingRangeFromSelection").run();
    }
  }
  set status(status) {
    this.widgetMap.status.html = status;
  }
  get isReadOnly() {
    return this.isFramework || this.fileExt === "html" || this.fileExt === "js" && (this.hasImports || isUmd);
  }
  toggleReadOnly() {
    const me = this, { contentElement, isReadOnly } = me;
    contentElement.classList.toggle("readonly", isReadOnly);
    if (isReadOnly) {
      me.status = "Read only" + (BrowserHelper.isCSP ? " (Restricted by Content Security Policy)" : !BrowserHelper.isChrome && !BrowserHelper.isFirefox ? " (try it on Chrome or Firefox)" : "");
    } else {
      me.status = "Idle";
    }
    me.editor.updateOptions({ readOnly: isReadOnly });
  }
  async loadCode(filename) {
    filename = `${this.appFolder}${filename}`;
    const me = this, { isVanilla } = me;
    let code = me.codeCache[filename], exception = null;
    me.filename = filename;
    if (!code) {
      try {
        const response = await AjaxHelper.get(location.href.replace(/[^/]*$/, "") + filename);
        code = me.codeCache[filename] = await response.text();
      } catch (e) {
        code = "";
        exception = e;
      }
    }
    me.loadedCode = code;
    me.fileExt = filename.split(".").pop();
    let language = "plaintext";
    switch (me.fileExt) {
      case "js":
      case "jsx":
        language = "javascript";
        break;
      case "ts":
      case "tsx":
      case "vue":
        language = "typescript";
        break;
      case "css":
        language = "css";
        break;
      case "scss":
        language = "scss";
        break;
      case "html":
        language = "html";
        break;
      case "json":
        language = "json";
        break;
    }
    me.language = language;
    const model = me.model = await me.loadText(code, language);
    model.findForwards = function(searchFor, searchStart) {
      const result = model.findNextMatch(...arguments);
      if (result && !result.range.getStartPosition().isBefore(searchStart)) {
        return result;
      }
    };
    if (isVanilla && me.fileExt === "js") {
      await me.collapseBoilerplate(model);
    }
    me.status = `${exception ? exception.message : "Idle"}`;
    me.toggleReadOnly();
  }
  sortFileNamesWithHierarchy(fileNames) {
    const createHierarchy = (fileNames2) => {
      const hierarchy = {};
      fileNames2.forEach((fileName) => {
        const parts = fileName.split("/");
        let current = hierarchy;
        parts.forEach((part, index) => {
          if (!current[part]) {
            current[part] = index === parts.length - 1 ? null : {};
          }
          current = current[part];
        });
      });
      return hierarchy;
    };
    const sortHierarchy = (hierarchy) => {
      const sortedHierarchy = {};
      const sortedKeys = Object.keys(hierarchy).sort((a, b) => {
        const isAFolder = hierarchy[a] !== null, isBFolder = hierarchy[b] !== null;
        if (isAFolder && !isBFolder)
          return -1;
        if (!isAFolder && isBFolder)
          return 1;
        return a.localeCompare(b);
      });
      sortedKeys.forEach((key) => {
        sortedHierarchy[key] = hierarchy[key] !== null ? sortHierarchy(hierarchy[key]) : hierarchy[key];
      });
      return sortedHierarchy;
    };
    const flattenHierarchy = (hierarchy, prefix = "") => {
      let result = [];
      Object.keys(hierarchy).forEach((key) => {
        const fullPath = `${prefix}${prefix !== "" ? "/" : ""}${key}`;
        if (hierarchy[key] === null) {
          result.push(fullPath);
        } else {
          result = result.concat(flattenHierarchy(hierarchy[key], fullPath));
        }
      });
      return result;
    };
    return flattenHierarchy(sortHierarchy(createHierarchy(fileNames)));
  }
  async initialLoadCode() {
    var _a, _b, _c;
    const me = this, { widgetMap, preferredSources } = me, { filesCombo } = widgetMap, filesStore = filesCombo.store, appConfig = `${me.appFolder}app.config.json`, appConfigJson = (await AjaxHelper.get(appConfig, { parseJson: true })).parsedJson, sources = [], isOnline = BrowserHelper.isBryntumOnline("online");
    if (me.isVanilla) {
      const noModule = (_b = (_a = appConfigJson.index) == null ? void 0 : _a.bundles) == null ? void 0 : _b.includes("es6");
      sources.push(
        isModule && !isOnline && !noModule ? "index.module.html" : isUmd ? "index.umd.html" : "index.html",
        (isModule || isOnline) && !noModule ? "app.module.js" : isUmd ? "app.umd.js" : "app.js"
      );
      if (!isModule && !isUmd && ((_c = appConfigJson.merge) == null ? void 0 : _c.length)) {
        me.hasImports = true;
        sources.push(...appConfigJson.merge);
      }
      if (document.head.querySelector('[href*="app.css"]')) {
        sources.push("resources/app.css");
      }
    } else {
      if (appConfigJson.source.length) {
        sources.push(...appConfigJson.source);
      } else {
        console.warn(`No source files loaded from ${appConfig}`);
      }
    }
    filesCombo.items = me.sortFileNamesWithHierarchy(sources).map((src) => ({
      text: src,
      value: src
    }));
    const preferredSource = (preferredSources || []).map((source) => filesStore.find((record) => source.test(record.value))).find(Boolean) || filesStore.first;
    filesCombo.value = preferredSource.value;
    await me.loadCode(preferredSource.value);
    filesCombo.onChange = "up.onFilesComboChange";
    me.toggleReadOnly();
    filesCombo.readOnly = filesStore.count === 1;
  }
  /**
   * Returns default monaco code path
   * @member {String|undefined}
   * @readobnly
   */
  static get monacoCodePath() {
    const match = /(.*?\/)examples/.exec(document.location.href);
    return match ? `${match[1]}examples/_shared/browser/lib/monaco-editor` : void 0;
  }
  /**
   * Shows / hides code editor
   * @param {Core.widget.DemoCodeEditor|undefined} editor current code editor instance
   * @param {Core.widget.Widget} button Show editor button
   * @param {Object} [editorConfig] New editor configuration
   * @returns {Core.widget.DemoCodeEditor}
   */
  static async toggleCodeEditor(editor, button, editorConfig) {
    const isNew = !editor;
    if (isNew) {
      editor = new _DemoCodeEditor({
        mode: "framework",
        appendTo: document.body,
        codePath: _DemoCodeEditor.monacoCodePath,
        appFolder: "../",
        ...editorConfig
      });
      Widget.disableThrow = true;
      button.icon = "b-icon-spinner";
      await editor.initialLoadCode();
      button.icon = "b-icon-code";
    }
    if (editor.collapsed) {
      await editor.expandPanel();
      editor.focus();
    } else {
      await editor.collapsePanel();
    }
    return editor;
  }
};
//region Config
__publicField(_DemoCodeEditor, "$name", "DemoCodeEditor");
__publicField(_DemoCodeEditor, "type", "democodeeditor");
__publicField(_DemoCodeEditor, "configurable", {
  /**
   * Editor mode
   * @config {'vanilla'|'framework'}
   */
  mode: "vanilla",
  /**
   * App folder location
   * @config {String}
   */
  appFolder: "",
  collapsible: {
    type: PanelCollapserOverlay.type,
    direction: "right",
    autoClose: false
    // don't remove the standard tools or the collapsed header height will be different and the animation
    // will start with a snap to the new header height.
    // recollapseTool : null,
    // tool           : null
  },
  collapsed: true,
  /**
   * Preferred source files.
   * First matched file from the list will be shown on initial load.
   * @config {RegExp[]}
   *
   */
  preferredSources: null,
  monitorResize: false,
  /**
   * An editor configuration object to be passed to https://microsoft.github.io/monaco-editor/docs.html#functions/editor.create.html
   * @config {Object}
   */
  editor: {
    lineNumbers: "off",
    foldingImportsByDefault: true,
    minimap: { enabled: false },
    ariaLabel: "Live code editor"
  },
  tbar: {
    overflow: null,
    items: {
      filesCombo: {
        type: Combo.type,
        flex: "1 1 100%",
        monitorResize: false,
        editable: false,
        fields: [{
          name: "text"
        }],
        listItemTpl: ({ text }) => {
          const fileExt = text.split(".").pop();
          let iconCls = "b-fa-file";
          switch (fileExt) {
            case "js":
            case "jsx":
            case "ts":
            case "tsx":
            case "vue":
              iconCls = "b-fa-file-lines";
              break;
            case "css":
            case "scss":
              iconCls = "b-fa-palette";
              break;
            case "htm":
            case "html":
            case "json":
              iconCls = "b-fa-file-code";
              break;
          }
          const lastSlashIndex = text.lastIndexOf("/") + 1, dirPath = text.substring(0, lastSlashIndex), fileName = text.substring(lastSlashIndex);
          return `<span class="b-editor-file-type b-fw-icon ${iconCls}" ></span> <span class="b-editor-folder">${dirPath}</span>${fileName}`;
        },
        picker: {
          maxHeight: "calc(100vh * 3 / 4)"
        }
      }
    }
  },
  codeCache: {}
});
__publicField(_DemoCodeEditor, "loadMonacoEditor", async (path) => {
  if (!CodeEditor.monacoLoadPromise) {
    const loader = DomHelper.createElement({
      tag: "script",
      parent: document.head,
      src: `${path}monaco-editor/min/vs/loader.js`
    });
    await new Promise((resolve) => loader.addEventListener("load", resolve));
    await (CodeEditor.monacoLoadPromise = new Promise((resolve) => {
      const r = globalThis["require"];
      r.config({ paths: { vs: `${path}monaco-editor/min/vs` } });
      r(["vs/editor/editor.main"], function() {
        resolve(globalThis.monaco);
      });
    }));
  }
});
let DemoCodeEditor = _DemoCodeEditor;
DemoCodeEditor.initClass();
DemoCodeEditor._$name = "DemoCodeEditor";
export {
  DemoCodeEditor as default
};
